import { render, staticRenderFns } from "./SourcingRecords.vue?vue&type=template&id=5b13b062&scoped=true"
import script from "./SourcingRecords.vue?vue&type=script&lang=js"
export * from "./SourcingRecords.vue?vue&type=script&lang=js"
import style0 from "./SourcingRecords.vue?vue&type=style&index=0&id=5b13b062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b13b062",
  null
  
)

export default component.exports